import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ShadeModal = ({ shadeModalIsOpen, closeShadeModal }) => {
    return (
        <Modal
            show={shadeModalIsOpen}
            onHide={closeShadeModal}
            backdrop='static'
            size='lg'
            centered
            contentClassName='background'
        >
            <Modal.Header>
                <Modal.Title>Shading</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>If part of your roof (and therefore part of the panels) is in the shade, that will reduce the amount of electricity that will be generated. If things like surrounding buildings, or trees, cast a shadow on your roof, please tell us roughly what proportion of the roof is shaded so we can factor that in to the calculations.</p>
                <p>If you want to know more about how to complete this section, you can refer to the shade evaluation guidance from your certification body.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button className='modal-button' onClick={closeShadeModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ShadeModal;
